import React from 'react';
import spinnerConfig from '%app/js/spinner-config';
import ReactSpinner from 'react16-spinjs';

const PayseraReactSpinner = () => {
    return (
        <div className="modal-backdrop">
            <ReactSpinner config={spinnerConfig} />
        </div>
    );
};

export default PayseraReactSpinner;
